import { render, staticRenderFns } from "./capaSei.vue?vue&type=template&id=13319dd4"
import script from "./capaSei.ts?vue&type=script&lang=js&external"
export * from "./capaSei.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/1/s/TafStore.PharmUP.Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13319dd4')) {
      api.createRecord('13319dd4', component.options)
    } else {
      api.reload('13319dd4', component.options)
    }
    module.hot.accept("./capaSei.vue?vue&type=template&id=13319dd4", function () {
      api.rerender('13319dd4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/crud/veterinario/capaSei/capaSei.vue"
export default component.exports